// extracted by mini-css-extract-plugin
export var videoHero = "_ba-4";
export var videoHeroImage = "_ba-5";
export var videoHeroOverlay = "_ba-6";
export var videoHeroSubtitle = "_ba-8";
export var videoHeroText = "_ba-7";
export var videoLauncher = "_ba-0";
export var videoLauncherIcon = "_ba-1";
export var videoLauncherSubtitle = "_ba-3";
export var videoLauncherTitle = "_ba-2";
export var videoPlayer = "_ba-a";
export var videoPlayerWrap = "_ba-9";